module.exports = __webpack_public_path__ + "img/help-icon-03.e6a13e1a.png";